import {
	CALENDAR_REQUEST,
	CALENDAR_REQUEST_SUCCESS,
	CALENDAR_REQUEST_FAILURE,
	CALENDAR_FILTERS_REQUEST,
	CALENDAR_FILTERS_REQUEST_SUCCESS,
	CALENDAR_FILTERS_REQUEST_FAILURE,
	CALENDAR_SET_ACTIVE_FILTER,
	CALENDAR_SET_ACTIVE_FILTER_PAGE,
	CALENDAR_FILTER_ATTRS_GET_SUPPOSE,
	CALENDAR_FILTER_ATTRS_GET_SUPPOSE_SUCCESS,
	CALENDAR_FILTER_ATTRS_GET_SUPPOSE_FAIL,
	CALENDAR_ADD_FILTER_ATTRS,
	CALENDAR_SAVE_FILTER_SUCCESS,
	CALENDAR_SAVE_FILTER_FAIL,
	CALENDAR_SAVE_FILTER,
	CALENDAR_DELETE_FILTER,
	CALENDAR_DELETE_FILTER_SUCCESS,
	CALENDAR_DELETE_FILTER_FAIL,
	CALENDAR_FILTER_PARAMS_GET_SUPPOSE,
	CALENDAR_FILTER_PARAMS_GET_SUPPOSE_SUCCESS,
	CALENDAR_FILTER_PARAMS_GET_SUPPOSE_FAIL,
	CALENDAR_FILTER_ATTRS_CLEAR_RESULT,
	CALENDAR_CLEAR_FILTER_ATTRS,
	CALENDAR_CLEAR_FILTER_INFO,
	CALENDAR_FILTER_DATA_GET_SUPPOSE,
	CALENDAR_FILTER_DATA_GET_SUPPOSE_SUCCESS,
	CALENDAR_FILTER_DATA_GET_SUPPOSE_FAIL,
	CALENDAR_OPEN_FILTER_PARAMS,
	CALENDAR_CLOSE_FILTER_PARAMS,
	CALENDAR_OPEN_NEW_FILTER_PARAMS,
	CALENDAR_CLOSE_NEW_FILTER_PARAMS,
	CALENDAR_CREATE_NEW_FILTER,
	CALENDAR_FILTER_LIST_GET_SUPPOSE,
	CALENDAR_FILTER_LIST_GET_SUPPOSE_SUCCESS,
	CALENDAR_FILTER_LIST_GET_SUPPOSE_FAIL,
	CALENDAR_FILTER_LIST_CLEAR_RESULT,
	CALENDAR_ADD_FILTER_OPTION,
	CALENDAR_SET_OLD_FILTER_DATA,
	CALENDAR_CLEAR_NEW_FILTER_OPTION,
	CALENDAR_CLEAR_FILTER_DATA,
	CALENDAR_APPLY_EXISTING_FILTER,
	CALENDAR_SET_SELECT_OPTIONS_FOR_FILTER,
	SEARCH_GET_CALENDAR_SUPPOSE,
	SEARCH_GET_CALENDAR_SUPPOSE_SUCCESS,
	SEARCH_GET_CALENDAR_SUPPOSE_FAILURE,
	CLEAR_SEARCH_GET_CALENDAR_SUPPOSE,
	CEVENT_GET_SUPPOSE,
	CEVENT_GET_SUPPOSE_SUCCESS,
	CEVENT_GET_SUPPOSE_FAILURE,
	RRULES_CEVENT_GET_SUPPOSE,
	RRULES_CEVENT_SUCCESS,
	RRULES_CEVENT_FAILURE,
	VALARM_CEVENT_GET_SUPPOSE,
	VALARM_CEVENT_SUCCESS,
	VALARM_CEVENT_FAILURE,
	TYPES_CEVENT_GET_SUPPOSE,
	TYPES_CEVENT_SUCCESS,
	TYPES_CEVENT_FAILURE,
	USER_CEVENTS_GET_SUPPOSE,
	USER_CEVENTS_SUCCESS,
	USER_CEVENTS_FAILURE,
	DELETE_CEVENTS_SUPPOSE,
	DELETE_CEVENT_SUCCESS,
	DELETE_CEVENT_FAILURE,
	STATUSES_CEVENTS_GET_SUPPOSE,
	STATUSES_CEVENTS_SUCCESS,
	STATUSES_CEVENTS_FAILURE,
	GET_DYN_PARAMS_CEVENT_GET_SUPPOSE,
	GET_DYN_PARAMS_CEVENT_SUCCESS,
	CEVENT_CLEAR_OPENED_EVENT
} from './constants';
/* initial state */
const initialState = {
	filters: null,
	
	loading: false,
	loaded: false,
	filterAttrsResults: [],
	checkedFilterAttrs: {},
	saving: false,
	saved: false,
	deleting: false,
	infoLoading: false,
	infoLoaded: false,
	infoFilterParams: [],
	filterList: [],
	loadingFilterList: false,
	loadedFilterList: false,
	lastSaved: '',
	dataLoading: false,
	dataLoaded: false,
	dataFilterResult: null,
	openedFilter: null,
	showFilterParams: false,
	newFilter: false,
	showDeleteFilterModal: false,
	newFilterOption: null,
	oldFilterData: null,
	
	data: null,
	total: null,
	
	openedEvent: null,
	eventLoading: false,
	
	rrules: null,
	rrulesLoading: false,
	
	valarms: null,
	valarmsLoading: false,
	
	types: null,
	typesLoading: false,
	
	userCalendars: null,
	calendarsLoading: false,
	
	eventStatuses: null,
	statusLoading: false,
	
	dynParams: null,
	mainDataLoading: false,
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case CALENDAR_FILTERS_REQUEST_SUCCESS:
			return { ...state, filters: action.filters };
		
		case CALENDAR_SET_ACTIVE_FILTER:
			return { ...state, openedFilter: action.openedFilter };
		
		case CALENDAR_SET_ACTIVE_FILTER_PAGE:
			const filters = state.filters;
			const currentIndex = filters.findIndex(filter => filter.filterId === action.filterId);
			const currentFilter = {...filters.find(filter => filter.filterId === action.filterId), page: action.page};
			filters[currentIndex] = currentFilter;
			
			return { ...state, filters };
		
		case CALENDAR_FILTER_ATTRS_GET_SUPPOSE:
			return {
				...state,
				loading: true,
				loaded: false
			};
		
		case CALENDAR_FILTER_ATTRS_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				loading: false,
				loaded: true,
				filterAttrsResults: action.result.result
			};
		
		case CALENDAR_FILTER_ATTRS_GET_SUPPOSE_FAIL:
			return {
				...state,
				loading: false,
				loaded: false,
				error: action.err
			};
		
		case CALENDAR_FILTER_ATTRS_CLEAR_RESULT:
			return {
				...state,
				filterAttrsResults: []
			};
		
		case CALENDAR_ADD_FILTER_ATTRS:
			
			return {
				...state,
				checkedFilterAttrs: action.result.result
			};
		
		case CALENDAR_CLEAR_FILTER_ATTRS:
			return {
				...state,
				checkedFilterAttrs: {}
			};
		
		case CALENDAR_SAVE_FILTER:
			return {
				...state,
				saving: true,
				saved: false
			};
		
		case CALENDAR_SAVE_FILTER_SUCCESS:
			const { lastSaved } = action;
			return {
				...state,
				saving: false,
				saved: true,
				newFilter: false,
				lastSaved
			};
		case CALENDAR_SAVE_FILTER_FAIL:
			return {
				...state,
				saving: false,
				saved: false,
				error: action.err
			};
		
		case CALENDAR_DELETE_FILTER:
			return {
				...state,
				deleting: true,
				deleted: false
			};
		
		case CALENDAR_DELETE_FILTER_SUCCESS:
			let stateFilters = state.filters;
			const currentDeletedIndex = stateFilters.findIndex(filter => filter.filterId === +action.id);
			stateFilters.splice(currentDeletedIndex, 1);
			return {
				...state,
				deleting: false,
				deleted: true,
				id: action.id,
				stateFilters
			};
		
		case CALENDAR_DELETE_FILTER_FAIL:
			return {
				...state,
				deleting: false,
				deleted: false,
				error: action.err
			};
		
		case CALENDAR_FILTER_PARAMS_GET_SUPPOSE:
			return {
				...state,
				infoLoading: true,
				infoLoaded: false
			};
		
		case CALENDAR_FILTER_PARAMS_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				infoLoading: false,
				infoLoaded: true,
				infoFilterParams: action.result.result,
				saved: false
			};
		
		case CALENDAR_FILTER_PARAMS_GET_SUPPOSE_FAIL:
			return {
				...state,
				infoLoading: false,
				infoLoaded: false,
				error: action.err
			};
		
		case CALENDAR_CLEAR_FILTER_INFO:
			return {
				...state,
				infoFilterParams: []
			};
		
		case CALENDAR_FILTER_LIST_GET_SUPPOSE:
			return {
				...state,
				loadingFilterList: true,
				loadedFilterList: false
			};
		
		case CALENDAR_FILTER_LIST_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				loadingFilterList: false,
				loadedFilterList: true,
				filterList: action.result.result
			};
		
		case CALENDAR_FILTER_LIST_GET_SUPPOSE_FAIL:
			return {
				...state,
				loadingFilterList: false,
				loadedFilterList: false,
				error: action.err
			};
		case CALENDAR_FILTER_LIST_CLEAR_RESULT:
			return {
				...state,
				filterList: []
			};
		
		case CALENDAR_ADD_FILTER_OPTION:
			return {
				...state,
				filterList: [
					...state.filterList,
					action.payload
				],
				newFilterOption: action.payload
			};
		
		case CALENDAR_SET_OLD_FILTER_DATA:
			return {
				...state,
				oldFilterData: action.payload
			};
		
		case CALENDAR_CLEAR_NEW_FILTER_OPTION:
			return {
				...state,
				newFilterOption: null
			};
		
		case CALENDAR_FILTER_DATA_GET_SUPPOSE:
			return {
				...state,
				dataLoading: true,
				dataLoaded: false
			};
		
		case CALENDAR_FILTER_DATA_GET_SUPPOSE_SUCCESS:
			
			return {
				...state,
				dataLoading: false,
				dataLoaded: true,
				dataFilterResult: action.result.result
			};
		
		case CALENDAR_FILTER_DATA_GET_SUPPOSE_FAIL:
			return {
				...state,
				dataLoading: false,
				dataLoaded: false,
				error: action.err
			};
		
		case CALENDAR_CLEAR_FILTER_DATA:
			return {
				...state,
				dataFilterResult: null
			};
		
		case CALENDAR_OPEN_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: true,
				newFilter: false
			};
		
		case CALENDAR_CLOSE_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: false
			};
		
		case CALENDAR_OPEN_NEW_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: true,
				newFilter: true
			};
		
		case CALENDAR_CLOSE_NEW_FILTER_PARAMS:
			return {
				...state,
				showFilterParams: false,
				newFilter: false
			};
		
		case CALENDAR_CREATE_NEW_FILTER:
			return {
				...state,
				newFilter: true
			};
		
		case CALENDAR_APPLY_EXISTING_FILTER:
			return {
				...state,
				newFilter: false
			};
		
		case CALENDAR_SET_SELECT_OPTIONS_FOR_FILTER:
			const { options, optionsHistory } = action;
			return {
				...state,
				selectOptions: options,
				optionsHistory
			};
		
		case SEARCH_GET_CALENDAR_SUPPOSE:
			return {
				...state,
				mainDataLoading: true,
			};
		
		case SEARCH_GET_CALENDAR_SUPPOSE_SUCCESS:
			return {
				...state,
				data: action.result,
				total: action.total,
				mainDataLoading: false,
			};
		case SEARCH_GET_CALENDAR_SUPPOSE_FAILURE:
		case CLEAR_SEARCH_GET_CALENDAR_SUPPOSE:
			return {
				...state,
				mainDataLoading: false,
			};
			
		case CEVENT_GET_SUPPOSE:
			return {
				...state,
				openedEvent: null,
				eventLoading: true
			};
		case CEVENT_GET_SUPPOSE_SUCCESS:
			return {
				...state,
				openedEvent: action.event,
				eventLoading: false,
			};
		case CEVENT_GET_SUPPOSE_FAILURE:
			return {
				...state,
				openedEvent: null,
				eventLoading: false
			};
		case CEVENT_CLEAR_OPENED_EVENT:
			return {
				...state,
				openedEvent: null
			};
		case RRULES_CEVENT_GET_SUPPOSE:
			return {
				...state,
				rrules: [],
				rrulesLoading: true
			};
		case RRULES_CEVENT_SUCCESS:
			return {
				...state,
				rrules: action.rrules,
				rrulesLoading: false,
			};
		case RRULES_CEVENT_FAILURE:
			return {
				...state,
				rrules: null,
				rrulesLoading: false
			};
			
		case VALARM_CEVENT_GET_SUPPOSE:
			return {
				...state,
				valarms: [],
				valarmsLoading: true
			};
		case VALARM_CEVENT_SUCCESS:
			return {
				...state,
				valarms: action.valarms,
				valarmsLoading: false,
			};
		case VALARM_CEVENT_FAILURE:
			return {
				...state,
				valarms: null,
				valarmsLoading: false
			};
			
		case TYPES_CEVENT_GET_SUPPOSE:
			return {
				...state,
				types: [],
				typesLoading: true
			};
		case TYPES_CEVENT_SUCCESS:
			return {
				...state,
				types: action.types,
				typesLoading: false,
			};
		case TYPES_CEVENT_FAILURE:
			return {
				...state,
				types: null,
				typesLoading: false
			};
			
		case USER_CEVENTS_GET_SUPPOSE:
			return {
				...state,
				userCalendars: [],
				calendarsLoading: true
			};
		case USER_CEVENTS_SUCCESS:
			return {
				...state,
				userCalendars: action.userCalendars,
				calendarsLoading: false,
			};
		case USER_CEVENTS_FAILURE:
			return {
				...state,
				userCalendars: null,
				calendarsLoading: false
			};
			
		case STATUSES_CEVENTS_GET_SUPPOSE:
			return {
				...state,
				eventStatuses: null,
				statusLoading: true
			};
		case STATUSES_CEVENTS_SUCCESS:
			return {
				...state,
				eventStatuses: action.eventStatuses,
				statusLoading: false,
			};
		case STATUSES_CEVENTS_FAILURE:
			return {
				...state,
				eventStatuses: null,
				statusLoading: false
			};
			
		case GET_DYN_PARAMS_CEVENT_GET_SUPPOSE:
			return {
				...state,
				dynParams: null,
			};
		case GET_DYN_PARAMS_CEVENT_SUCCESS:
			return {
				...state,
				dynParams: action.dynParams,
			};
			
		case DELETE_CEVENTS_SUPPOSE:
			return {
				...state,
				eventLoading: true
			};
		case DELETE_CEVENT_SUCCESS:
			return {
				...state,
				openedEvent: null,
				eventLoading: false,
			};
		case DELETE_CEVENT_FAILURE:
			return {
				...state,
				eventLoading: false
			};
		
		default:
			return state;
	}
};
